import React, { useMemo } from 'react';
import { Star } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { getClientDetail } from '@/utils/routeHelpers';
import styles from './ProductList.module.css';
import { POPULAR_CATEGORY_ID } from '@/data/categories';
import {
    calculateAverageRating,
    filterProductsForCategory,
} from '@/utils/productCategories';
import { isProductLikedLocally } from '@/utils/productLikes';
import favBtn from '@/ui/assets/icons/favBtn.svg';

function ProductList({ activeCategory, searchTerm, products, reviewerId }) {
    const navigate = useNavigate();

    const filteredProducts = useMemo(
        () => filterProductsForCategory(products, activeCategory, searchTerm),
        [activeCategory, searchTerm, products]
    );

    const emptyMessage = useMemo(() => {
        if (searchTerm?.trim()) {
            return 'No se encontraron productos con esa búsqueda.';
        }
        if (activeCategory === POPULAR_CATEGORY_ID) {
            return 'No hay productos con calificaciones aún.';
        }
        return 'No hay productos en esta categoría.';
    }, [activeCategory, searchTerm]);

    if (!products || products.length === 0) {
        return <div><p>Cargando desde Firebase...</p></div>;
    }

    return (
        <main className={styles.productGrid}>
            {filteredProducts.length > 0 ? (
                filteredProducts.map((p) => {
                    const average = calculateAverageRating(p.comments);
                    const isPopularView = activeCategory === POPULAR_CATEGORY_ID;

                    const handleProductClick = () => {
                        try {
                            localStorage.setItem('client_selected_product_id', p.id);
                        } catch (error) {
                            console.error("Error guardando el ID del cliente en localStorage:", error);
                        }

                        navigate(getClientDetail(p.id), { state: p });
                    };

                    const hasLiked = isProductLikedLocally(p.id);

                    return (
                        <div
                            className={styles.productCard}
                            key={p.id}
                            onClick={handleProductClick}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className={styles.imageContainer}>
                                <img className={styles.imageContainerImage} src={p.image_url} alt={p.name} />
                                {hasLiked && (
                                    <div className={styles.likeHeart}>
                                        <img src={favBtn} alt="Me gusta" className={styles.likeHeartIcon} />
                                    </div>
                                )}
                            </div>

                            <div className={styles.productInfo}>
                                <h3 className={styles.productTitle}>{p.name}</h3>

                                <div className={styles.productMeta}>
                                    <span className={styles.price}>
                                        $ {Number(p.price).toLocaleString('es-CO')}
                                    </span>

                                    <span className={styles.rating}>
                                        <Star size={14} color='#FFB84D' fill='#FFB84D' />
                                        {average > 0 ? average.toFixed(1) : "0"}
                                    </span>



                                </div>
                            </div>
                        </div>
                    );
                })
            ) : (
                <p className={styles.noProducts}>{emptyMessage}</p>
            )}
        </main>
    );
}

export default ProductList;
